module.exports = __webpack_public_path__ + "img/20.eeb2a327.png";